import React from "react";
import { Headphones, RotateCcw, ShieldCheck, Truck } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Secure Payment" },
  { icon: Truck, label: "Fast Shipping" },
  { icon: RotateCcw, label: "Easy Returns" },
  { icon: Headphones, label: "Customer Support" },
];

const TrustBadges = () => (
  <section className="border-y border-white/10 bg-[#0d0d0d]" data-testid="trust-badges">
    <div className="grid grid-cols-2 md:grid-cols-4 md:divide-x md:divide-white/10">
      {items.map(({ icon: Icon, label }) => (
        <div key={label} className="flex min-h-[68px] items-center gap-3 border-b border-white/10 px-4 py-4 md:min-h-[78px] md:border-b-0 md:px-6">
          <Icon className="text-cynos-red shrink-0" size={22} />
          <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-white md:text-[11px]">
            {label}
          </span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustBadges;
